//手Q定位API
var util = require("../util");
var config = require('../config');

var useTecentGeo = function() {
  return  /TBS/i.test(navigator.userAgent) && ~config.get('enables').indexOf('x5');
};


module.exports = function (suc, fail, next) {
    if (!useTecentGeo()) {
        next();
    } else {
        util.loadScript("//apis.map.qq.com/tools/geolocation/min?key=6ULBZ-4X3C3-QEK3S-3ZRI6-6D7RE-WQFRQ&referer=大众点评M站", function () {
            try{
                var x5Geo = new qq.maps.Geolocation();

                x5Geo.getLocation(function(location) {
                    suc({
                        lat: location.lat,
                        lng: location.lng
                    })
                },fail)              
            }catch(e){
                next()
            }

        });
    }
};

module.exports.type = "x5";


// WEBPACK FOOTER //
// ./~/@dp/whereami/lib/geos/x5.js